<label tuiLabel>
	<div class="organization-selector__label-row">
		<p>
			{{ 'navigation.organization' | transloco }}
		</p>

		@if (loading()) {
			<div class="organization-selector__loading">
				<tui-loader size="xs" />
				<p class="text-xs">
					{{ 'action.loading' | transloco }}
				</p>
			</div>
		}
	</div>

	<tui-textfield
		#textfieldRef
		[content]="textfieldRef.focused() ? '' : orgValueContent"
		tuiDropdownSheet
		tuiTextfieldSize="m"
	>
		<tui-data-list-wrapper
			*tuiDropdown
			[itemContent]="orgItemContent"
			[items]="(organizationOptions$ | async) ?? [] | tuiFilterByInput"
		/>

		<ng-template #orgValueContent let-option>
			@if (option) {
				<span class="organization-selector__value">
					@if (option.logoUrl) {
						<img
							class="organization-selector__value-logo"
							[src]="option.logoUrl"
							[alt]="option.name"
						/>
					} @else {
						<span class="organization-selector__value-placeholder">
							{{ option.toString().charAt(0) }}
						</span>
					}
					{{ option.toString() }}
				</span>
			}
		</ng-template>

		<ng-template #orgItemContent let-option>
			<div class="organization-selector__item">
				@if (option.logoUrl) {
					<img
						class="organization-selector__item-logo"
						[src]="option.logoUrl"
						[alt]="option.name"
					/>
				} @else {
					<span class="organization-selector__item-placeholder">
						{{ option.toString().charAt(0) }}
					</span>
				}
				<span class="organization-selector__item-name">
					{{ option.toString() }}
				</span>
			</div>
		</ng-template>

		<input tuiComboBox [formControl]="orgControl" />
	</tui-textfield>
</label>

<div class="flex justify-end">
	<button
		tuiButton
		size="s"
		type="button"
		class="mt-4"
		[disabled]="!canSelect || disabled()"
		(click)="onSelect()"
		[loading]="disabled()"
	>
		{{ 'action.select' | transloco }}
	</button>
</div>
